// SVG inline flags for the language switcher.
// Trusted content — safe to use with innerHTML.

export function flagFR() {
  return `<svg viewBox="0 0 30 20" width="22" height="15" xmlns="http://www.w3.org/2000/svg" class="flag" aria-hidden="true">
    <rect width="10" height="20" fill="#002395"/>
    <rect x="10" width="10" height="20" fill="#fff"/>
    <rect x="20" width="10" height="20" fill="#ED2939"/>
  </svg>`;
}

export function flagGB() {
  return `<svg viewBox="0 0 60 30" width="22" height="15" xmlns="http://www.w3.org/2000/svg" class="flag" aria-hidden="true">
    <rect width="60" height="30" fill="#012169"/>
    <path stroke="#fff" stroke-width="6" d="M0 0l60 30M60 0L0 30"/>
    <path stroke="#C8102E" stroke-width="2" d="M0 0l60 30M60 0L0 30"/>
    <path stroke="#fff" stroke-width="10" d="M30 0v30M0 15h60"/>
    <path stroke="#C8102E" stroke-width="6" d="M30 0v30M0 15h60"/>
  </svg>`;
}
